import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { AppComponent } from '../app.component';
import { cloneDeep, cloneDeepWith } from "lodash";
import { TreeviewItem } from 'ngx-treeview';

@Component({
  selector: 'app-modal-autres-finitions',
  templateUrl: './modal-autres-finitions.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal-autres-finitions.component.less']
})
export class ModalAutresFinitionsComponent implements OnInit {
  @Output() emitService: EventEmitter<any> = new EventEmitter<any>();
  globalTxt: any;
  modalsTxt: any;
  finitions: any = [];
  finitionSelected: any = null;
  modalInfo: any;
  dmgId: any;
  //@Output() emitService = new EventEmitter();
  config: any = {
    //hasAllCheckBox: true,
    //hasFilter: false,
    //hasCollapseExpand: false,
    //decoupleChildFromParent: true,
    //maxHeight: 500
  }

  constructor(
    public app: AppComponent,
  ) { }

  ngOnInit(): void {
    // ==> On recupere la modalInfo en cours from data-tools pour pouvoir acceder à la fonction qui ferme la modal
    this.app.dataToolsService.currentModalInfo.subscribe(modalInfo => {
      //console.log("modalInfo  => ", modalInfo);
      this.modalInfo = modalInfo;

      this.getInfosInit();
    });

  }

  addMe(_data: any) {
    console.log("addMe _data => ", _data);

    let params: any = {
      fin: (_data) ? _data : null,
      dmgId: this.dmgId
    }

    console.log("addMe params => ", params);


    this.app.dataToolsService.setObjAutreFinition(params);
    this.modalInfo.noFn();
  }

  getInfosInit() {
    // ==> On GET le JSON des Textes globaux
    this.app.dataToolsService.currentGlobalTexts.subscribe(object => {

      // ==> Si l'objet n'est pas encore défini dans les dataTools, alors on appele la fonction dans sharedTools pour remplir l'objet dans les dataTools
      if (!object)
        this.app.sharedToolsService.getGlobalTexts();

      this.globalTxt = object;

      // ==> On CALL les textes des modals
      this.app.sharedToolsService.getJSON('txtModals').subscribe(resp => {
        console.log("resp ==> ", resp);

        this.modalsTxt = cloneDeep(resp.autresFinitions);

        let modalData = JSON.parse(localStorage.getItem('modalOpen')!);

        this.dmgId = (modalData) ? modalData.dmgId : null;
        ///this.finitions = (modalData) ? modalData.data : [];
        let finitionsTemp: any = (modalData) ? modalData.data : [];

       //console.log("finitionsTemp", finitionsTemp)

        this.finitions = this.getTreeView(finitionsTemp);
        this.finitions.forEach((_fin: any) => {
          _fin.checked = false;
        });
      })
    });
  }

  getTreeView(_array: any) {
    let finitions: TreeviewItem[] = [];

    _array.forEach((_fin: any) => {
      let checked: boolean = false;

      let tvItem = new TreeviewItem({
        text: _fin.Label,
        value: _fin.Id,
        checked: checked,
        children: (!_fin.children) ? [] : this.getTreeView(_fin.children),
        collapsed: true
      });

     finitions.push(tvItem);
    });
    //console.log("=============================>", finitions);
    return finitions;
  }

  // ==> On met tous les items du treeview à false sauf le dernier selectionné
  setAllTreeViewToFalse(_array: any, _id: any) {
    _array.forEach((tvItem: any) => {
      if (tvItem.value == _id) return;
    
      if (tvItem.checked) tvItem.checked = false;
      if (tvItem.internalChecked) tvItem.internalChecked = false;

      if (tvItem.children && tvItem.children.length > 0) this.setAllTreeViewToFalse(tvItem.children, _id);
    });

    return _array;
  }

  onSelectedChange(_item: any) {
    _item.internalChecked = !_item.internalChecked;
    _item.checked = !_item.checked;

    this.finitionSelected = null;

    let finSel:any = {
      Label: (_item) ? _item.text : null,
      Id: (_item) ? _item.value : null,
      selected: (_item) ? true : false,
    }

    this.finitionSelected = finSel;

    if (this.finitions) this.finitions = this.setAllTreeViewToFalse(this.finitions, this.finitionSelected.Id);
  }

  onClickPanelFin(_fin: any, _id: any) {
    _fin.show = !_fin.show;

    let id = document.getElementById(_id);
    console.log(id);

    if (id) {
      id.classList.toggle("show");
    }
  }
}
